import {AfterViewInit, Directive, ElementRef, Input} from '@angular/core';
import {annotate} from "rough-notation";
import {StoryTheme} from "../story/card/story-theme";
import {StoryService} from "../story/story.service";
import {CdColor} from "../enums/cd-color";
import {RoughAnnotation, RoughAnnotationType, RoughPadding} from "rough-notation/lib/model";

@Directive({
  selector: '[brtRoughText]'
})
export class RoughTextDirective implements AfterViewInit{

  @Input('selector') selector?: string;
  @Input('iterations') iterations: number = 1;
  @Input('color') set setColor(val: StoryTheme) {
    switch (val) {
      case StoryTheme.BLACK: this.color = '#181818'; break;
      case StoryTheme.DARKBLUE: this.color = '#204074'; break;
      case StoryTheme.DARKGREEN: this.color = '#106c40'; break;
      case StoryTheme.GREY: this.color = '#e0e0e0'; break;
      case StoryTheme.LIGHTBLUE: this.color = '#2996d2'; break;
      case StoryTheme.LIGHTGREEN: this.color = '#15a050'; break;
      case StoryTheme.PETROL: this.color = '#1e5f6e'; break;
      case StoryTheme.RED: this.color = '#fa2027'; break;
      case StoryTheme.WHITE: this.color = '#ffffff'; break;
      case StoryTheme.YELLOW: this.color = '#fbc800'; break;
      default: this.color = '#15a050';
    }
  }
  @Input('type') type: RoughAnnotationType = "circle";
  @Input('state') set setState(newState: "run" | "stop") {
    clearTimeout(this.stateTimeout);
    this.currentState = newState;
    if(newState === "run") {
      if(this.roughInstance) {
        this.stateTimeout = window.setTimeout(() => {
          this.roughInstance.show();
        }, 400);
      } else {
        this.stateTimeout = window.setTimeout(() => {
          let padding: RoughPadding = [0,0,0,0];
          if(this.type === "circle") padding = [10, 10, 10, 10];
          // console.log(this.el);
          let htmlEl = this.el.nativeElement as HTMLElement;
          if(this.selector && this.selector.length > 0) {
            const targetEl = htmlEl.querySelector(this.selector);
            if(targetEl) {
              htmlEl = targetEl as HTMLElement;
            }
          }
          htmlEl.style.maxWidth = "100%";
          htmlEl.style.display = "inline";
          // Only establish a positioning context if the element has none. Overwriting an
          // existing `position: absolute` (e.g. .card-time) would drop it back into the
          // normal flow, where the card's centering flex layout moves it.
          if(window.getComputedStyle(htmlEl).position === "static") {
            htmlEl.style.position = "relative";
          }
          htmlEl.innerHTML = `<span style="display: inline; width: max-content; max-width: 100%;">${htmlEl.innerHTML}</span>`;
          htmlEl.classList.add("roughed");
          const innerSpan = htmlEl.querySelector("span");
          if(innerSpan) {
            this.roughInstance = annotate(innerSpan, {
              type: this.type,
              animationDuration: 1000,
              iterations: this.iterations,
              padding: padding,
              color: this.color,
              multiline: true
            });

            const createdSvg = innerSpan.parentElement?.querySelector("svg")
            if(createdSvg) {
              createdSvg.setAttribute("aria-hidden", "true");
            }

            setTimeout(() => {
              if(this.currentState === "run") {
                if(this.roughInstance) this.roughInstance.show();
              }
            }, 100);
          }
        }, 400);
      }
    } else {
      if(this.roughInstance) {
        this.roughInstance.hide();
      }
    }
  }
  color: string = "";

  stateTimeout = -1;
  currentState: "run" | "stop" = "stop";

  roughInstance!: RoughAnnotation;
  constructor(private el: ElementRef, private storyService: StoryService) { }

  ngAfterViewInit() {



  }
}
